(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const toggleBtn = document.querySelector('.header-menu__toggle');
    const menu = document.querySelector('.header-menu');

    toggleBtn.addEventListener('click', () => {
      menu.classList.toggle('header-menu--active');

      if (menu.classList.contains('header-menu--active')) {
        toggleBtn.textContent = 'Close';
      } else {
        toggleBtn.textContent = 'Menu';
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["newsletter"] && !Shopify.designMode) return;
  try {
    const input = document.querySelector('[data-input]');
  const display = document.querySelector('[data-display]');
  const maxLength = 27;

  let isFocused = false;

  function updateDisplay() {
    const value = input.value;
    const underscores =
      value || isFocused ? '_'.repeat(Math.max(0, maxLength - value.length - 1)) : '_'.repeat(maxLength);
    if (isFocused) {
      display.innerHTML = value + '<span class="newsletter__cursor">&block;</span>' + underscores;
    } else {
      display.textContent = value ? value + ' ' + underscores : underscores;
    }
  }

  input.addEventListener('input', updateDisplay);
  input.addEventListener('focus', function () {
    isFocused = true;
    updateDisplay();
  });
  input.addEventListener('blur', function () {
    isFocused = false;
    updateDisplay();
  });

  // Initial display
  updateDisplay();
  } catch(e) { console.error(e); }
})();

})();
